import Dashboard from "../Dashboard";
import { useEffect, useState } from "react";
import {Link} from 'react-router-dom'
function Location() {
    const [data,setData]=useState([]);
    const [otherLocation,setLocationData]=useState([]);
    useEffect(()=>{

      Promise.all([
        fetch('https://travelapp-8fhf.onrender.com/locations'),
        fetch('https://travelapp-8fhf.onrender.com/hotels')
      ])
      .then(([locations, hotels])=>
        Promise.all([locations.json(), hotels.json()])
      ).then((data) => {
        setData(data[0]);
        setLocationData(data[1]);
      })

    })
    return (
      <>
        <Dashboard />
        <section className="featuresWrap location">
              {
                data.map((item,i)=>
                <Link to={'/details/'+item._id} key={i}>
                  <div className="fw__box">
                    <picture><img src={item.photo[0]} alt="" /></picture>
                    <h4>{item.name}
                      {/* <small>{item.details}</small> */}
                    </h4>
                  </div> 
                </Link>
                )
              }       
        </section>     
        
        <section className="otherLocations">
          {
            otherLocation.map((oLocation,i)=>
              <div className="otherLocationBox" key={i}>
                <h4>{oLocation.name}</h4>
              </div>
            )
          }
        </section>
      </>
      
    );
  }
  
  export default Location;